import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './errors'

/**
 * ADR-0024 D9 - TanStack Query como cliente de dados unico (cache,
 * revalidacao, repeticao em falha, estado de carregamento).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Nao repetir erro de autenticacao/autorizacao: repetir nao resolve e
        // ainda polui a trilha de auditoria do backend (ADR-0011).
        if (error instanceof ApiError && (error.isUnauthorized || error.isForbidden)) {
          return false
        }
        return failureCount < 2
      },
    },
    mutations: { retry: false },
  },
})
